<template>
	<app-header>
		<template #brand>
			<a class="navbar-item header-logo gtm-header-nav-logo" href="/">
				<img
					src="~@/assets/dc_header_logo.svg"
					alt="DailyAccess"
					class="dc-logo"
				/>
			</a>
		</template>
		<template #navigation>
			<navigation class="navbar-start"></navigation>
		</template>
		<template #logo>
			<div class="navbar-item">
				<user-level-badge :type="currentUser.type" />
			</div>
		</template>
	</app-header>
</template>

<script>
import AppHeader from "@shared/Layout/Header";
import UserLevelBadge from "./UserLevelBadge";
import Navigation from "./Navigation";

export default {
	name: "AccessHeader",
	components: { AppHeader, UserLevelBadge, Navigation }
};
</script>

<style scoped>
.dc-logo {
	width: 35px;
	max-height: 2rem;
}
</style>
